import React, { useMemo } from 'react';
import { createFieldFormatPercentageFunction } from 'shared/utils';
import { DataGrid } from '../../DataGrid';
import { BacktestingExceptionsGridProps } from '../types';
import { getFields } from '../utils';
import { GRID_ROW_HEIGHT, GRID_HEADER_ROW_HEIGHT } from '../constants';
import './BacktestingExceptionsGrid.scss';

export const BacktestingExceptionsGrid: React.FC<
  BacktestingExceptionsGridProps
> = ({ dataFromApi, onCellPrepared, height }): JSX.Element => {
  const customizeText = createFieldFormatPercentageFunction(0);
  const fields = useMemo(() => getFields({ customizeText }), [customizeText]);
  const calculatedGridHeight = useMemo(
    () => dataFromApi.length * GRID_ROW_HEIGHT + GRID_HEADER_ROW_HEIGHT,
    [dataFromApi]
  );
  const setHeightValue = useMemo(() => {
    if (!height) return undefined;
    return `${height > calculatedGridHeight ? calculatedGridHeight : height}`;
  }, [height, calculatedGridHeight]);
  return (
    <DataGrid
      title="Exceptions"
      dataSource={dataFromApi}
      fields={fields}
      height={setHeightValue}
      showBorders
      showRowLines
      onCellPrepared={onCellPrepared}
      scrolling={{ mode: 'virtual' }}
    />
  );
};
